import loaderGif from './loader.gif'
import logoSvg from './logo.svg'
import radarobservationheightPng from './radarobservationheight.png'
import keravaradar_smallJpg from './keravaradar_small.jpg'

const image = {
  logo: logoSvg,
  loading: loaderGif,
  keravaRadar: keravaradar_smallJpg,
  radarObservationHeight: radarobservationheightPng
}

export default image



// WEBPACK FOOTER //
// ./src/images/index.ts